export default __webpack_public_path__ + "static/media/Clipboard.069ec054.svg";